// extracted by mini-css-extract-plugin
module.exports = {"main":"tab-general_main__k4oZE","root":"tab-general_root__1zU73"};